import {Brick, registerBrick, ErrorFlow} from 'olympe';

export default class GetPunchOutCatalogInfo extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} resultFromPG
     * @param {function(string)} setURL
     * @param {function(string)} setFrom
     * @param {function(string)} setSharedSecret
     * @param {function(string)} setUserId
     * @param {function(string)} setFullName
     * @param {function(string)} setEmail
     */
    update($, [punchOutCatalogInfo, userInfo], [setURL, setFromDomain, setFromId, setToDomain, setToId, setSenderDomain, setSenderId, setSharedSecret, setUserId, setFullName, setEmail, setSupplierSetupURL, setAddressName, setCountry, setCompanyCode, setErrorFlow]) {
        try {
            const punchOut = JSON.parse(punchOutCatalogInfo)[0];

            setURL(punchOut.url);
            setFromDomain(punchOut.from_domain);
            setFromId(punchOut.from_id);
            setToDomain(punchOut.to_domain);
            setToId(punchOut.to_id);
            setSenderDomain(punchOut.sender_domain);
            setSenderId(punchOut.sender_id);
            setAddressName(punchOut.address_name);
            setSupplierSetupURL(punchOut.supplier_setup_url);
            setCountry(punchOut.country);
            setSharedSecret(punchOut.password);
            setCompanyCode(punchOut.company_code);
            setUserId(userInfo.id);
            setFullName(userInfo.description);
            setEmail(userInfo.email);
        } catch (e) {
            setErrorFlow(ErrorFlow.create(`Cannot read punchOut or user info: ${e}`, 1));
        }
    }
}

registerBrick('01956b54d16ba4ad6621', GetPunchOutCatalogInfo);
